import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackIntegrationDisconnected.meta';

export type UseTrackIntegrationDisconnectedParams = {
  integration_id: string;
  integration_name: string;
  trackLocation?: 'integrations-settings';
};

export const useTrackIntegrationDisconnected = () => {
  const { track } = useAnalyticsUtilities();

  const trackIntegrationDisconnected = useCallback(
    (params: UseTrackIntegrationDisconnectedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackIntegrationDisconnected };
};
